import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ServerConnectionStatusComponent} from "../../components/server-connection-status/server-connection-status.component";

@Component({
  selector: 'app-server-connection-status',
  templateUrl: './server-connection-status.component.html',
  styleUrls: ['./server-connection-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServerConnectionStatusComponent21 extends ServerConnectionStatusComponent{

  public region = null;

  initializeListeners() {
    super.initializeListeners();
    this.serverConnection.onAction('region', (r) => { this.region = r; this.cd.detectChanges();});
  }
}
